import React from 'react';
import styled from '@emotion/styled';
import { N700 } from '@atlaskit/theme/colors';
import { fontCharlieDisplay, ParagraphOversized } from '../styled';
import { TABLET_BREAKPOINT } from '../styled';

export const PageHeader = ({
  title,
  subheadings
}: {
  title: JSX.Element;
  subheadings?: JSX.Element[];
}) => (
  <FormHeaderContainer>
    <FormHeaderHeading>{title}</FormHeaderHeading>
    {subheadings?.length &&
      subheadings.map((subheading, i) => (
        <ParagraphOversized key={i}>{subheading}</ParagraphOversized>
      ))}
  </FormHeaderContainer>
);

const FormHeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 40px;
  max-width: 600px;
`;

const FormHeaderHeading = styled.h1`
  color: ${N700};
  font-family: ${fontCharlieDisplay};
  font-weight: 500;
  font-size: 36px;
  line-height: 1.22222222;
  margin-top: 0;
  margin-bottom: 16px;

  @media (min-width: ${TABLET_BREAKPOINT}) {
    font-size: 48px;
    line-height: 1.16666667;
    margin-bottom: 24px;
  }
`;
